var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-title"},[_c('h1',{staticClass:"title",class:_vm.headerClass,style:(_vm.textStyle())},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"underline",style:(_vm.stripeStyle())})])
}
var staticRenderFns = []

export { render, staticRenderFns }